<section class="hero is-primary mb-8">
  <div class="container-full">
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="hero-body px-0 py-9">
            <div class="columns">
              <div class="column is-8-tablet is-6-widescreen">
                <div class="is-flex align-items-center mb-4">
                  <h1 class="title is-2 has-text-weight-bold">
                    Monitoring Tax Support for R&D and innovation
                  </h1>
                </div>
              </div>
            </div>
            <div class="columns is-multiline">
              <div class="column column--cta is-3-desktop">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-space-between is-fullheight"
                >
                  <div
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start is-flex-direction-column"
                  >
                    <figure class="image">
                      <i class="fa-solid fa-globe is-size-4 mb-2"></i>
                    </figure>
                    <p class="has-text-weight-bold mt-2 mb-6 mb-0-mobile">
                      Explore R&D tax incentives within one country
                    </p>
                  </div>
                  <a
                    routerLink="/countries"
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start has-text-link has-text-weight-bold"
                  >
                    <i class="fas fa-arrow-right-long mr-1"></i>
                    <span class="has-text-weight-bold">Explore a country</span>
                  </a>
                </div>
              </div>
              <div class="column column--cta is-3-desktop">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-space-between is-fullheight"
                >
                  <div
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start is-flex-direction-column"
                  >
                    <figure class="image">
                      <i class="fa-solid fa-chart-simple is-size-4 mb-2"></i>
                    </figure>

                    <p class="has-text-weight-bold mt-2 mb-6 mb-0-mobile">
                      Review the latest indicators and OECD analysis on R&D tax
                      incentives
                    </p>
                  </div>
                  <a
                    routerLink="/indicators-and-analysis"
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start has-text-link has-text-weight-bold"
                  >
                    <i class="fas fa-arrow-right-long mr-1"></i>
                    <span class="has-text-weight-bold">Access indicators</span>
                  </a>
                </div>
              </div>
              <div class="column column--cta is-3-desktop">
                <div
                  class="is-flex is-flex-direction-column is-justify-content-space-between is-fullheight"
                >
                  <div
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start is-flex-direction-column"
                  >
                    <figure class="image">
                      <i class="fa-solid fa-book-open is-size-4 mb-2"></i>
                    </figure>
                    <p class="has-text-weight-bold mt-2 mb-6 mb-0-mobile">
                      Search and compare the design of R&D tax incentives
                    </p>
                  </div>
                  <a
                    routerLink="/incentives"
                    class="is-flex is-align-items-flex-start is-justify-content-flex-start has-text-link has-text-weight-bold"
                  >
                    <i class="fas fa-arrow-right-long mr-1"></i>
                    <span class="has-text-weight-bold"
                      >Select tax incentives</span
                    >
                  </a>
                </div>
              </div>
              <div class="column column--cta is-12-touch is-3-desktop">
                <app-country-comparison-widget></app-country-comparison-widget>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="container">
  <!-- Data visualization -->
  <div class="columns">
    <div class="column">
      <h2 class="title is-3 has-text-weight-bold has-line">
        Design of R&D tax incentives at a glance
      </h2>
    </div>
  </div>

  <app-aggregation-widget
    [loading]="loadingAggregations"
    [aggregations]="aggregations"
  ></app-aggregation-widget>

  <div class="columns">
    <div class="column">
      <h2 class="title is-3 has-text-weight-bold has-line mt-4">
        Generosity of R&D tax incentives
      </h2>
      <div class="content">
        <p>
          Implied tax subsidy rates on R&D tax incentives, calculated as 1 minus
          the
          <a
            target="_blank"
            href="https://one.oecd.org/document/DSTI/STP/NESTI(2023)2/FINAL/en/pdf"
            download
            >B-Index</a
          >, provide a synthetic representation of the generosity of the tax
          system in incentivising business R&D investment.
        </p>
        <p>
          <a
            routerLink="/indicators-and-analysis"
            class="icon-text no-deco ml-1"
          >
            <span class="icon">
              <i class="fas fa-circle-right mr-1 has-text-link"></i>
            </span>
            <span
              >Explore additional OECD indicators and analysis on R&D tax
              incentives</span
            >
          </a>
        </p>
      </div>
    </div>
  </div>

  <app-aggregation-widget
    [loading]="loadingAggregations"
    [aggregations]="[otherAggregation]"
  ></app-aggregation-widget>

  <div class="columns mt-4 mb-8" *ngIf="additionalResources">
    <div class="column is-12">
      <div
        class="card card--info has-background-white-bis is-fullheight is-shadowless"
      >
        <div class="card-content p-8 p-4-mobile">
          <div class="content">
            <h2 class="title is-3 has-text-weight-bold has-line">
              Additional resources
            </h2>

            <p>
              R&D tax incentives have become a major tool in the business
              innovation support policy mix of countries in the OECD area and
              beyond. Since 2007, the OECD has continuously worked to extend the
              international evidence on the use, generosity, cost and impacts of
              R&D tax incentives. Recent OECD publications include:
            </p>
            <ul>
              <li *ngFor="let additionalResource of additionalResources">
                <a [href]="additionalResource.link" target="_blank"
                  >{{ additionalResource.anchor }}
                </a>
                <ng-container *ngIf="additionalResource['extra-text']"
                  >&nbsp;
                  {{ additionalResource['extra-text']['pre-title'] }}
                  <a
                    [href]="additionalResource['extra-text'].link"
                    target="_blank"
                    >{{ additionalResource['extra-text'].anchor }}</a
                  >
                  {{ additionalResource['extra-text']['post-title'] }}
                </ng-container>
              </li>
            </ul>

            <p>
              <a
                [routerLink]="['/indicators-and-analysis']"
                fragment="resources"
                class="icon-text no-deco"
              >
                <span class="icon">
                  <i class="fas fa-circle-right mr-1 has-text-link"></i>
                </span>
                <span>Discover additional resources and related OECD work</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
